import { Owlmoji } from '@readme/markdown-legacy';
import React, { useCallback } from 'react';

import useClassy from '@core/hooks/useClassy';

import Button from '@ui/Button';
import Dropdown from '@ui/Dropdown';
import EmojiPicker from '@ui/EmojiPicker';
import Icon from '@ui/Icon';

import classes from './index.module.scss';

interface IconSelectorProps {
  updatePageIcon: (value: { name: string | null; type: string | null }) => void;
  value: {
    name: string | null;
    type: string | null;
  };
}

const IconSelector = ({ updatePageIcon, value }: IconSelectorProps) => {
  const bem = useClassy(classes, 'IconSelector');

  const handleIconClick = useCallback(
    (name: string, type: string) => {
      if (name && type) {
        const iconName = type === 'icon' ? name : Owlmoji.nameToEmoji[name];
        updatePageIcon({ name: iconName, type });
      } else {
        updatePageIcon({ name: null, type: null });
      }
    },
    [updatePageIcon],
  );

  const isEmptyState = !value.name && !value.type;

  return (
    <Dropdown align="bottom" appendTo={() => document.body} justify="start" sticky>
      <Button
        {...(!isEmptyState && { 'aria-label': 'Edit page icon' })}
        data-testid="icon-toggle"
        kind="secondary"
        outline
        size="sm"
      >
        {isEmptyState ? (
          <span>Icon</span>
        ) : (
          <>
            <span className={bem('-Icon')}>
              {value.type === 'icon' ? (
                <i aria-hidden="true" className={value.name ?? undefined} />
              ) : (
                <span aria-hidden="true">{value.name}</span>
              )}
            </span>
          </>
        )}
        <Icon aria-hidden="true" name="chevron-down" />
      </Button>
      <EmojiPicker
        onClick={(name, type) => handleIconClick(name, type)}
        owlmoji={false}
        showIcons={true}
        value={value.name ?? undefined}
      />
    </Dropdown>
  );
};

export default IconSelector;
